/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { NgModule } from '@angular/core';
import { MsalModule, MsalService } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { environment } from 'environments/environment';
import { MsalWrapperService } from 'app/modules/msal-wrapper/services/msalwrapper.service';

@NgModule({
  imports: [
    // Without this section we get NullInjectorErrors when we try to dependency inject MsalService.
    // Relocated from SandboxModule/DashboardModule now that OutboundEmailModule needs it as well. I'm not sure it's a good idea to have it in multiple modules.
    MsalModule.forRoot( new PublicClientApplication({
      auth: {
        clientId: environment.microsoftGraphApplicationId,
        authority: "https://login.microsoftonline.com/" + MsalWrapperService.tenantId,
        redirectUri: MsalWrapperService.redirectUris
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false, // Set to true for Internet Explorer 11
      }
    }),
    {
      interactionType: InteractionType.Popup, // MSAL Guard Configuration
      authRequest:{scopes: MsalWrapperService.scopes}
    }
    , null)

  ],
  declarations: [
  ],
  exports: [
  ],
  providers: [
    MsalService,
    MsalWrapperService,
  ]
})
export class MsalWrapperModule {}
